import { FC } from "react";
import { IonContent, IonPage } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { assignmentPlatform } from "refsix-core";
import { IntegrationPartner } from "refsix-js-models";
import { HeaderComponent, ToastComponent } from "../../../../components";
import { AssignmentPlatformCard } from "../../../../components/integrations/assignments/AssignmentPlatformCard";
import { useAssignmentImport } from "../../../../components/integrations/assignments/useAssignmentImport";
import { routes } from "../../../../route/constants";

/**
 * MOAS (The FA, England) — appointments imported by scraping the referee's own
 * schedule page in an in-app WebView (REFSIX-568).
 *
 * MOAS has no public API and has agreed to nothing, so the page says so: no
 * platform mark, and the disclaimer before the import button.
 *
 * Everything the referee sees is shared with the other scraped platforms, in
 * components/integrations/assignments — this page is the catalogue entry, the
 * route and the title.
 */
// The catalogue is static and core's parity test fails if the entry is missing.
const PLATFORM = assignmentPlatform(IntegrationPartner.moas)!;

export const MoasIntegration: FC = () => {
    const { t } = useTranslation();
    const { importing, lastImport, toastMessage, dismissToast, startImport } =
        useAssignmentImport(PLATFORM);

    return (
        <IonPage>
            <HeaderComponent
                showBackButton
                defaultHref={routes.refsixMoreIntegrations}
                title={t("integrations.assignments.unofficialName", {
                    platform: PLATFORM.displayName,
                })}
                titleTestId="assignment-platform-page-header"
            />
            <IonContent>
                <AssignmentPlatformCard
                    platform={PLATFORM}
                    importing={importing}
                    lastImport={lastImport}
                    onImport={startImport}
                />
                <ToastComponent
                    isOpen={!!toastMessage}
                    message={toastMessage}
                    position="bottom"
                    onDismiss={dismissToast}
                />
            </IonContent>
        </IonPage>
    );
};

export default MoasIntegration;
